import { BaseMutations } from '@/store/base-mutations';
import Vue from 'vue';
import PollsState from './state';
import { Polls } from '../types';

export default class PollsMutations extends BaseMutations<PollsState> {
  SET_POLLS(polls: Polls.Poll[]) {
    this.state.polls = polls;
  }

  SET_CURRENT_POLL(current_poll: Polls.CurrentPoll) {
    this.state.current_poll = current_poll;
  }

  TOGGLE_STEPPER_LOADING(value: boolean) {
    this.state.stepper_loading = value;
  }

  UPDATE_QUESTION_FIELD({ question_id, updated_field }: { question_id: number; updated_field: Partial<Polls.Answers> }) {
    const index = this.state.questions.findIndex((q) => q.id === question_id);

    if (index !== -1) {
      Vue.set(this.state.questions, index, { ...this.state.questions[index], ...updated_field });
    }
  }

  PUSH_QUESTION(item: Polls.Answers) {
    this.state.questions.push(item);
  }

  TOGGLE_HAS_SENT(value: boolean) {
    this.state.has_sent = value;
  }

  SET_START_TIME(value: string) {
    this.state.start_time = value;
  }

  TOGGLE_SUCCESS_DIALOG(value: boolean) {
    this.state.show_success_dialog = value;
  }

  CLEAR_POLL() {
    this.state.questions = [];
    this.state.poll_id = null;
  }

  CLEAR_START_TIME() {
    this.state.start_time = '';
  }

  SET_IS_MATCHED_ROUTE_SLUG(value: boolean) {
    this.state.is_matched_route_slug = value;
  }

  SET_POLL_ID(value: number) {
    this.state.poll_id = value;
  }
}
